import { HEALTH_URL } from 'framework/enums/cacheEnum'
import { onUnmounted } from 'vue'
import { bestLineOptions } from '@admin/enums/pageEnum'
const bestHealthUrl = ref<string>('')
let intervalId: number | null = null
import { getQueryVariable } from 'framework/utils/index'

export default function () {
  const getLocation = () => {
    return new Promise((resolve) => {
      fetch('https://get.geojs.io/v1/ip/geo.json')
        .then((res) => res.json())
        .then((data) => {
          resolve(data.country_code)
        })
        .catch(() => {
          resolve('CN')
        })
    })
  }

  const loopFindBestLine = async () => {
    const lineParam = getQueryVariable('l')

    if (lineParam) {
      const lineIndex = Number(lineParam)
      const selectedLine = bestLineOptions[lineIndex]?.value
      if (selectedLine) {
        localStorage.setItem(HEALTH_URL, selectedLine)
        bestHealthUrl.value = selectedLine
      }
    } else if (!localStorage.getItem(HEALTH_URL)) {
      const countryCode = await getLocation()
      const bestUrl = countryCode === 'CN' ? bestLineOptions[0].value : bestLineOptions[1].value
      if (bestUrl) {
        localStorage.setItem(HEALTH_URL, bestUrl)
        bestHealthUrl.value = bestUrl
      }
    }
  }

  //开始定时
  const startPolling = (immediately = true, isLoop = false) => {
    immediately && loopFindBestLine() // 立即执行一次
    isLoop && (intervalId = window.setInterval(loopFindBestLine, 10000)) // 每30秒执行一次,默认不轮询
  }

  //停止定时器
  const stopPolling = () => {
    if (intervalId) {
      clearInterval(intervalId)
      intervalId = null
    }
  }

  onUnmounted(() => {
    stopPolling()
  })

  return {
    bestHealthUrl,
    startPolling,
  }
}
